/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>question-control.service.ts</name>
///
/// <description>
/// A service for transforming our questions to a FormGroup. 
/// The form group consumes the metadata from the question model and allows us to specify default values and validation rules.
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>28 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 28Dec16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------

import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators} from '@angular/forms';

import { CUIDynamicFormQuestionBase } from './question-base';

@Injectable()
export class CUIDynamicFormQuestionControlService {
    constructor() { }

    toFormGroup(questions: CUIDynamicFormQuestionBase<any>[]) {
        let group: any = {};

        questions.forEach(question => {
            let validators = [];
            if (question.required)
                validators.push(Validators.required);
            if (question.validationRegEx && question.validationRegEx.length > 0)
                validators.push(Validators.pattern(question.validationRegEx));
            if (question.email)
                validators.push(this.validateEmail);
            if (question.userName)              
                validators.push(this.validateUserName);             
            if (question.password)
                validators.push(Validators.compose([Validators.minLength(8), Validators.maxLength(32), Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!"#$%&\'()*+,-./:;<=>?@\^_`{|}~]+')])); //Must contain letters (both uppercase and lowercase) and number.
            if (question.mobileNumber)
                validators.push(this.validateMobileNumber);         
      
            if (question.hasdependencyon) {
                if (question.hasdependencyon.value)
                    validators.push(Validators.required);
                group[question.key] = validators.length > 0 ? new FormControl(question.value || '', validators)
                    : new FormControl(question.value || '');
                group[question.hasdependencyon.key] = new FormControl(question.hasdependencyon.value || '');
            }
            else {
                group[question.key] = validators.length > 0 ? new FormControl(question.value || '', validators)
                    : new FormControl(question.value || '');
            }

        });
        return new FormGroup(group);
    }

    private validateEmail(c: FormControl) {
        //YH 1/31/2017 Bug 122317 - UsersListdoes hangs
        //let EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;

        if (c.value == "") return null;

        return EMAIL_REGEXP.test(c.value) ? null : {
            validateEmail: {
                valid: false
            }
        };
    }

    private validateUserName(c: FormControl) {

        //YH 3/8/2017 the regex below does not match alphanumeric at all
        //let USERNAME_REGEXP = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/;;  //should be alphanumeric character only. No special like @ etc.
        let USERNAME_REGEXP = /^(?![0-9]*$)[a-zA-Z0-9]+$/;
        
        return USERNAME_REGEXP.test(c.value) ? null : {
            validateUserName: {
                valid: false
            }
        };
    }

    private validateMobileNumber(c: FormControl) {
        if (c.value == "") return null;

        let PHONE_REGEXP = /^\+[1-9]{1}[0-9]{3,14}$/;

        return PHONE_REGEXP.test(c.value) ? null : {
            validateMobileNumber: {
                valid: false
            }
        };
    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dynamic-form/question-control.service.ts